import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcements-viewed"
export default class extends Controller {
  connect() {
    // Dispatch event to update the sidebar badge count when announcements page is loaded
    window.dispatchEvent(new CustomEvent('announcements:viewed'));
  }
}

